import React from 'react';
import { Layout, Typography } from 'antd';

function NotFound() {
    return (
        <Layout.Content>
            <Typography.Title level={3}>This page does not exist.</Typography.Title>
        </Layout.Content>
    );
}

export default NotFound;
